/*
 * Public API Surface of super-code
 */

export { FormErrorComponent } from './lib/components/form-error/form-error.component';

export { SuperEmojis } from './lib/core/emojis';
export { SuperObserveQueue } from './lib/core/observeQueue';
export { SuperObserveList } from './lib/core/observeList';


export { NgLetDirective } from './lib/directives/ng-let.directive';
export {
    SuperPipeSizeFormat,
    SuperPipeToFixedFormat,
    SuperPipeLengthFormat,
    SuperPipeMomentFormat,
    SuperPipeUcFirst,
    SuperPipeToLVFormat,
    SuperPipeGetKeys
} from './lib/pipes/format.pipe';
export { ArraySortPipe, ReversePipe } from './lib/pipes/sorts.pipe';
export { FilterByKeyValue, SearchByValue, SearchByKeyValue, minDate, maxDate, FilterByObject, findArrayFilter } from './lib/pipes/filter.pipe';
export { ReturnFirst, ReturnLast, ReturnWithout } from "./lib/pipes/array.pipe";

export * from './lib/directives/@directives.module';
export * from './lib/pipes/@pipes.module';
export * from './lib/validators/validators';
export * from './lib/super-code.service';
export * from './lib/super-code.component';
export * from './lib/super-code.module';
export * from './lib/core/supermoment';
export { SuperUtils } from './lib/core/utils';